import { useState } from 'react';
import { Send, Clock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';
import { API } from '../../config/api';
import { Button } from '../ui/button';

export function ScheduledPanel({ scheduledReleases, onRefresh }) {
  const [processingScheduled, setProcessingScheduled] = useState(false);
  const handleProcessScheduled = async () => {
    setProcessingScheduled(true);
    try {
      const { data } = await api.post(`${API}/releases/process-scheduled`, {}, { withCredentials: true });
      toast.success(data.message);
      onRefresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Failed to process scheduled releases');
    } finally {
      setProcessingScheduled(false);
    }
  };
  return (
            <div className="space-y-6" data-testid="scheduled-content">
              <div className="flex items-center justify-between">
                <h2 className="font-cabinet text-2xl font-black uppercase tracking-tighter">
                  SCHEDULED RELEASES
                </h2>
                <Button
                  onClick={handleProcessScheduled}
                  disabled={processingScheduled}
                  className="bg-[#FF3B30] hover:bg-white hover:text-[#0A0A0A] rounded-none"
                  data-testid="process-scheduled-btn"
                >
                  {processingScheduled ? (
                    <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Processing...</>
                  ) : (
                    <><Send className="w-4 h-4 mr-2" /> Process Due Releases</>
                  )}
                </Button>
              </div>

              <p className="text-[#A3A3A3]">
                Tracks with scheduled release dates will auto-publish and notify pre-savers when the time comes.
              </p>

              {scheduledReleases.length === 0 ? (
                <div className="bg-[#141414] border border-[#262626] p-12 text-center">
                  <Clock className="w-12 h-12 mx-auto text-[#A3A3A3] mb-4" />
                  <p className="text-[#A3A3A3]">No scheduled releases.</p>
                  <p className="text-[#A3A3A3] text-sm mt-2">Set a scheduled release date when creating a track.</p>
                </div>
              ) : (
                <div className="bg-[#141414] border border-[#262626]">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Track</th>
                        <th>Artist</th>
                        <th>Scheduled For</th>
                        <th>Pre-saves</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scheduledReleases.map(track => (
                        <tr key={track.id}>
                          <td className="font-medium">{track.title}</td>
                          <td className="text-[#A3A3A3]">{track.artist}</td>
                          <td className="font-mono text-[#FF3B30]">
                            {track.scheduled_release_at ? new Date(track.scheduled_release_at).toLocaleString() : '-'}
                          </td>
                          <td className="font-mono">{track.presave_count || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

  );
}
